import { IParticipantPosition } from 'APIPackage/DictionariesModule/interfaces/IParticipantPosition';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryParticipantPositionSelectOption = makeCreateDictionarySelectOption<IParticipantPosition>(
  'guid',
  'title',
);
